import React, { useState } from "react";

export const CustomToastContent = ({ msg, description, counts, isSuccess }) => {
  const [isExpanded, setIsExpanded] = useState(false);
   
  const showExpand = description && description !== msg;

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <strong>{msg || (isSuccess ? "Success" : "Upload Failed")}</strong>
          
        {showExpand && (
          <button
            onClick={(e) => {
              e.stopPropagation();  
              setIsExpanded(!isExpanded);
            }}
            style={{
              background: "transparent", border: "none", color: "inherit",
              cursor: "pointer", marginLeft: "10px", fontSize: "16px", padding: "0"
            }}
          >
            {isExpanded ? "▲" : "▼"} 
          </button>
        )}
      </div>

      {counts?.success !== undefined && (
        <div style={{ marginTop: '8px', fontSize: '12px', fontWeight: 'bold' }}>
          <span style={{ color: 'green' }}>Success: {counts.success}</span> |{" "}
          <span style={{ color: 'red' }}>Error: {counts.error}</span> |{" "}
          <span style={{ color: 'orange' }}>Duplicate: {counts.duplicate}</span>
        </div>
      )}

      {isExpanded && showExpand && (
        <div style={{ fontSize: "13px", marginTop: "8px", wordBreak: "break-word" }}>
          <strong>Details:</strong> {description}
        </div>
      )}
    </div>
  );
};